<template>
  <v-container fluid grid-list-md py1>
    <data-table ref="plantillaCorreoTable" @editRow="load" @auditRow="audit" />

    <v-layout row wrap class="mb-5">
      <v-flex md12>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.generales.plantillaCorreo.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <v-form @keyup.ctrl.83="executeValidators">
                  <v-layout row wrap>
                    <!-- Clave -->
                    <v-flex md6>
                      <v-text-field
                        v-model="$v.plantillaCorreo.clave.$model"
                        :disabled="view.elem.input.clave.disabled || view.action.submit.busy"
                        :error-messages="getFirstErrorDescription($v.plantillaCorreo.clave)"
                        :label="$t('view.commons.clave')"
                        dense />
                    </v-flex>

                    <!-- Descripción -->
                    <v-flex md6>
                      <v-text-field
                        v-model="$v.plantillaCorreo.descripcion.$model"
                        :disabled="view.action.submit.busy"
                        :error-messages="getFirstErrorDescription($v.plantillaCorreo.descripcion)"
                        :label="$t('view.generales.plantillaCorreo.form.descripcion.label')"
                        dense />
                    </v-flex>

                    <!-- Destinatarios Opcionales -->
                    <v-flex md6>
                      <v-text-field
                        v-model="$v.plantillaCorreo.destinatariosOpcionales.$model"
                        :disabled="view.action.submit.busy"
                        :error-messages="getFirstErrorDescription($v.plantillaCorreo.destinatariosOpcionales)"
                        :label="$t('view.generales.plantillaCorreo.form.destinatariosOpcionales.label')"
                        dense />
                    </v-flex>

                    <!-- Multi List Perfiles Destinatarios -->
                    <v-flex md6>
                      <v-autocomplete
                        v-model="$v.plantillaCorreo.multiListPerfilesDestinatarios.$model"
                        :items="view.elem.select.groups.options"
                        :label="$t('view.generales.plantillaCorreo.form.multiListPerfilesDestinatarios.label')"
                        :error-messages="getFirstErrorDescription($v.plantillaCorreo.multiListPerfilesDestinatarios)"
                        :disabled="view.action.submit.busy"
                        item-text="name"
                        item-value="code"
                        hide-no-data
                        deletable-chips
                        clearable
                        multiple
                        small-chips
                        dense
                        :no-data-text="$t('view.commons.nodata')" />
                    </v-flex>

                    <!-- Asunto -->
                    <v-flex md6>
                      <v-text-field
                        v-model="$v.plantillaCorreo.asunto.$model"
                        :disabled="view.action.submit.busy"
                        :error-messages="getFirstErrorDescription($v.plantillaCorreo.asunto)"
                        :label="$t('view.generales.plantillaCorreo.form.asunto.label')"
                        dense />
                    </v-flex>

                    <!-- Remitente -->
                    <v-flex md6>
                      <v-text-field
                        v-model="$v.plantillaCorreo.remitente.$model"
                        :disabled="view.action.submit.busy"
                        :error-messages="getFirstErrorDescription($v.plantillaCorreo.remitente)"
                        :label="$t('view.generales.plantillaCorreo.form.remitente.label')"
                        dense />
                    </v-flex>

                    <!-- cuerpo -->
                    <v-flex md12 class="form-group cuerpo" style="margin-bottom: 60px" :class="[hasErrors($v.plantillaCorreo.cuerpo) ? 'has-error' : '']">
                      <label for="cuerpo">{{ $t("view.generales.plantillaCorreo.form.cuerpo.label") }}</label>
                      <vue-editor v-model="plantillaCorreo.cuerpo" :editor-options="editorSettings" style="height: 350px" :disabled="view.action.submit.busy" />
                      <label v-if="$v.plantillaCorreo.cuerpo.$dirty" class="error--text" for="cuerpo">
                        {{ $t(`validator.${getFirstError($v.plantillaCorreo.cuerpo)}.text`) }}
                      </label>
                    </v-flex>

                    <!-- Estatus -->
                    <v-flex md12 class="mt-5">
                      <label for="status" class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                      <v-switch v-model="plantillaCorreo.status" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-flex shrink>
                  <v-btn
                    v-show="plantillaCorreo.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                    id="btnaudit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.audit')"
                    :loading="view.action.submit.busy"
                    @click="audit()">
                    <v-icon small>storage</v-icon>
                  </v-btn>

                  <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
                    <v-icon small>fa-eraser</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="$userPermission.hasPermission('ROLE_MODIFICAR_CATALOGOS')"
                    id="btnsubmit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.submit.title.current"
                    :loading="view.action.submit.busy"
                    :disabled="form.$state.isDisableButtonSubmit()"
                    @click="submit()">
                    <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>
    </v-layout>

    <auditoria ref="auditModal" />
  </v-container>
</template>

<script>
import plantillaCorreoStates from "@/views/generales/plantillaCorreo/plantilla-correo-state"; /** *******************************/
import PlantillaCorreoAPI from "@/services/generales/plantillaCorreo";
import DataTable from "@/views/generales/plantillaCorreo/DataTable";
import Auditoria from "@/components/auditoria/Auditoria";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required, email, maxLength } from "vuelidate/lib/validators";
import { emailList } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { VueEditor, Quill } from "vue2-editor";
import { IndentStyle } from "@/helpers/quill-extensions";
import { ImageDrop } from "quill-image-drop-module";
import { submit } from "@/constants/buttons";
import ImageResize from "quill-image-resize-module";
import tippy from "tippy.js";

Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);

const input = { clave: { disabled: true } };

const action = { submit: { busy: false } };

let select = { groups: { options: [{ name: "ADMINISTRADOR", code: "1" }] } };

export default {
  name: "PlantillaCorreoModule"
  , components: {
    DataTable
    , Auditoria
    , VueEditor
  }
  , data() {
    return {
      editorSettings: {
        modules: {
          imageDrop: true
          , imageResize: {}
          , toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }]
            , ["bold", "italic", "underline", "strike"]
            , [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }]
            , [{ list: "ordered" }, { list: "bullet" }] // , {'list':'check'}
            , [{ indent: "+1" }, { indent: "-1" }]
            , [{ color: [] }, { background: [] }]
            , ["link", "image"]
            , ["clean"]
          ]
        }
      }
      , plantillaCorreo: undefined
      , state: new Object()
      , view: {
        title: this.$t("view.generales.plantillaCorreo.title")
        , action
        , elem: {
          button: { submit }
          , select
          , input
          , showForm: true
        }
      }
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , async created() {
    this.form = new plantillaCorreoStates(this);
    this.form.$setState("initial");

    // Configures quill plugin
    const AlignStyle = Quill.import("attributors/style/align");
    Quill.register(AlignStyle, true);
    Quill.register(IndentStyle, true);
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.plantillaCorreo);
        handleResponse(respuesta, this.$t("view.generales.plantillaCorreo.errors"));
      } catch (error) {
        console.log(error);
        handleResponse(error, this.$t("view.generales.plantillaCorreo.errors"));
      }
    }
    , async load(idPlantillaCorreo) {
      try {
        const response = await PlantillaCorreoAPI.get({ clave: idPlantillaCorreo });
        const { data: { results: { plantillaCorreo } } } = response;
        this.form.$setState("editing", plantillaCorreo);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.plantillaCorreo.clave, dataDescripcion = this.plantillaCorreo.descripcion) {
      this.$refs.auditModal.loadAudit(clave, "TPlantillaCorreo", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
  }
  , validations: {
    plantillaCorreo: {
      clave: {
        required
        , maxLength: maxLength(30)
      }
      , remitente: {
        required
        , email
        , maxLength: maxLength(255)
      }
      , descripcion: {
        required
        , maxLength: maxLength(255)
      }
      , multiListPerfilesDestinatarios: {
        required: false
        , maxLength: maxLength(1000)
      }
      , destinatariosOpcionales: {
        emailList: emailList(";")
        , maxLength: maxLength(1000)
      }
      , cc: {
        emailList: emailList(";")
        , maxLength: maxLength(1000)
      }
      , cco: {
        emailList: emailList(";")
        , maxLength: maxLength(1000)
      }
      , asunto: {
        required
        , maxLength: maxLength(255)
      }
      , cuerpo: { required }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.quill-editor {
  height: 300px !important;
  padding-bottom: 3rem;
}
.cuerpo .error--text {
  position: absolute;
  margin-top: 55px;
}
</style>



// WEBPACK FOOTER //
// src/views/generales/plantillaCorreo/PlantillaCorreo.vue